import { useTranslations } from '@ms/yammer-i18n-react';
import TeamsStrings from '@ms/yammer-strings/dist/Teams';
import { vivaEngageLogoPath } from '@ms/yammer-web-components/dist/images';
import { FixedGridColumn, FixedGridRow } from '@ms/yammer-web-core-ui/dist/components/FixedGrid';
import Image from '@ms/yammer-web-core-ui/dist/components/Image';
import SemanticHeading from '@ms/yammer-web-core-ui/dist/components/SemanticHeading';
import Text from '@ms/yammer-web-core-ui/dist/components/Text';
import { useTheme } from '@ms/yammer-web-core-ui/dist/util/theme';
import React, { FC } from 'react';

import { getClassNames } from './AppHeaderLogo.styles';

const AppHeaderLogo: FC = () => {
  const theme = useTheme();
  const t = useTranslations(TeamsStrings);
  const classNames = getClassNames(theme);
  const headerText = t.manifestVivaEngageNameShort();

  return (
    <FixedGridRow columnSpacing={2}>
      <FixedGridColumn className={classNames.logoImage} width={32} fixed={true}>
        <Image source={vivaEngageLogoPath} height={24} width={24} description="" />
      </FixedGridColumn>
      <FixedGridColumn verticalAlign="top" className={classNames.logoText}>
        <Text weight="bold" size={400}>
          {headerText}
        </Text>
        <SemanticHeading level={1} screenreaderOnly={true}>
          {headerText}
        </SemanticHeading>
      </FixedGridColumn>
    </FixedGridRow>
  );
};

export default AppHeaderLogo;
